// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"940":"1cb31e69","968":"814c1ec6"}[chunkId] + ".js";
};